import { useContext } from 'react';
import { FlatsFiltersContentContext, FlatsFiltersOpenedContext } from '../FlatsFiltersContext';

export const useFilterReset = (skipKeys) => {
  const [opened, setOpened] = useContext(FlatsFiltersOpenedContext);
  const { searchParams, updateSearchParams, activeFiltersCount } = useContext(
    FlatsFiltersContentContext,
  );
  const body = document.querySelector('body');

  const resetParams = () => {
    const newSearchParams = { ...searchParams };
    Object.keys(newSearchParams).forEach((key) => {
      if (skipKeys?.includes(key)) return;
      if (Array.isArray(newSearchParams[key])) {
        newSearchParams[key] = [];
      } else {
        newSearchParams[key] = null;
      }
    });

    return newSearchParams;
  };

  const handleResetClick = () => {
    body.classList.remove('UIPopup-no-scroll');
    setOpened(!opened);
    updateSearchParams(resetParams());
  };

  return {
    handleResetClick,
    disabled: activeFiltersCount === 0,
  };
};
